import { defineMessages } from "react-intl"

export const listingScoreHintsMessages = defineMessages({
	description: {
		defaultMessage:
			"Listings are ordered in the search results in a certain way based on several different factors. " +
			"The hints given below will help you to improve the rank of your listing.",
		id: "vehicleDetails.scoreHints.description",
	},
	descriptionNoSuggestions: {
		defaultMessage:
			"Good work! By incorporating all the listing performance suggestions, " +
			"you have enhanced the position of your listing in the search results.",
		id: "vehicleDetails.scoreHints.description.noSuggestions",
	},
	expansionToggleButtonLabelCollapsed: {
		defaultMessage: "Show suggestions",
		id: "vehicleDetails.scoreHints.expansionToggleButtonLabel.collapsed",
	},
	expansionToggleButtonLabelExpanded: {
		defaultMessage: "Hide suggestions",
		id: "vehicleDetails.scoreHints.expansionToggleButtonLabel.expanded",
	},
	headline: {
		defaultMessage: "Listing Quality",
		id: "inventoryListFilters.listingQuality.heading",
	},
	headlineSuggestionsAddition: {
		defaultMessage: "({completed}/{total} completed suggestions)",
		id: "vehicleDetails.scoreHints.headlineSuggestionsAddition",
	},
})
